module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Part_01",
      "id": "pt1"
    }
  }, [_vm._v("EASTERN APPROACHES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Chapter_01",
      "id": "ch1"
    }
  }, [_vm._v("Kindly Stranger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Chapter_02",
      "id": "ch2"
    }
  }, [_vm._v("Give Us This Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/10_Chapter_03",
      "id": "ch3"
    }
  }, [_vm._v("Dionysus and the Pard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/11_Chapter_04",
      "id": "ch4"
    }
  }, [_vm._v("Low Water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Part_02",
      "id": "pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROMANIA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter_05",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sabres on the Sand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter_06",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cook-runner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Part_03",
      "id": "pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HUNGARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter_07",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tell These Men to Go Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter_08",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Picket Lines of Marton Hevessy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter_09",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roll Out the Barrel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Part_04",
      "id": "pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter_10",
      "id": "ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water of Iturrigorri")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter_11",
      "id": "ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three of Castile")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter_12",
      "id": "ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pejemuller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter_13",
      "id": "ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Technique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter_14",
      "id": "ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secret Police")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Part_05",
      "id": "pt5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENGLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter_15",
      "id": "ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twilight of a God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter_16",
      "id": "ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Greeks Had No Word for It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter_17",
      "id": "ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs as Ain’t")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter_18",
      "id": "ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abner of the Porch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Part_06",
      "id": "pt6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/31_Chapter_19",
      "id": "ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sword and the Rake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/32_Chapter_20",
      "id": "ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Champion Antiochus")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b8f8cf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Contents.vue
// module id = 66
// module chunks = 0